import React from "react";

const AlertOctagonIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_6545_36057)">
        <path
          d="M10.7821 0.000976562H5.21844C5.02277 0.000976562 4.92493 0.000976562 4.83286 0.0230806C4.75123 0.042678 4.67319 0.0750015 4.60162 0.118864C4.52088 0.168338 4.4517 0.237519 4.31334 0.37588L0.375147 4.31407C0.236786 4.45243 0.167605 4.52162 0.118132 4.60235C0.074269 4.67393 0.0419456 4.75196 0.0223482 4.83359C0.000244141 4.92566 0.000244141 5.0235 0.000244141 5.21917V10.7828C0.000244141 10.9785 0.000244141 11.0763 0.0223482 11.1684C0.0419456 11.25 0.074269 11.328 0.118132 11.3996C0.167605 11.4803 0.236784 11.5495 0.375141 11.6879L0.375148 11.6879L4.31334 15.6261L4.31335 15.6261C4.4517 15.7644 4.52088 15.8336 4.60162 15.8831C4.67319 15.927 4.75123 15.9593 4.83286 15.9789C4.92493 16.001 5.02277 16.001 5.21844 16.001H10.7821C10.9777 16.001 11.0756 16.001 11.1676 15.9789C11.2493 15.9593 11.3273 15.927 11.3989 15.8831C11.4796 15.8336 11.5488 15.7644 11.6871 15.6261L11.6871 15.6261L15.6253 11.6879L15.6254 11.6879C15.7637 11.5495 15.8329 11.4803 15.8824 11.3996C15.9262 11.328 15.9585 11.25 15.9781 11.1684C16.0002 11.0763 16.0002 10.9785 16.0002 10.7828V5.21917C16.0002 5.0235 16.0002 4.92566 15.9781 4.83359C15.9585 4.75196 15.9262 4.67393 15.8824 4.60235C15.8329 4.52162 15.7637 4.45244 15.6253 4.31408L15.6253 4.31407L11.6871 0.37588C11.5488 0.237519 11.4796 0.168338 11.3989 0.118864C11.3273 0.0750015 11.2493 0.042678 11.1676 0.0230806C11.0756 0.000976562 10.9777 0.000976562 10.7821 0.000976562Z"
          fill="#D92D20"
        />
        <path
          d="M7.99951 4.93164V7.99964M7.99951 11.0676H8.00718"
          stroke="#FFFBFA"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6545_36057">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { AlertOctagonIcon };
